<nav aria-label="breadcrumb" class="p-3">
    <ol class="breadcrumb custom-breadcrumb">
        <li class="breadcrumb-item">
            <a [routerLink]="'/home'" class="text-decoration-none">Home</a>
        </li>
    </ol>
</nav>
<div class="container-fluid">
    <div class="row">
        <div class="col-2">
            <ul class="nav flex-column nav-tabs" role="tablist">
                <li class="nav-item nav-tab">
                    <a class="nav-link py-3"
                       [routerLink]="'/home/groups'"
                       routerLinkActive="active-link"
                       [routerLinkActiveOptions]="{ exact: true }">
                        Organizations
                    </a>
                </li>
                <li class="nav-item nav-tab">
                    <a class="nav-link py-3"
                       [routerLink]="'/home/sites'"
                       routerLinkActive="active-link"
                       [routerLinkActiveOptions]="{ exact: true }">
                        Sites
                    </a>
                </li>
                <li class="nav-item nav-tab">
                    <a class="nav-link py-3"
                       [routerLink]="'/home/event-logs'"
                       routerLinkActive="active-link"
                       [routerLinkActiveOptions]="{ exact: false }">
                        Event Logs
                    </a>
                </li>
                <li class="nav-item nav-tab" *ngIf="isDevtoolEnabled">
                    <a class="nav-link py-3"
                       [routerLink]="'/home/dev-tool'"
                       routerLinkActive="active-link"
                       [routerLinkActiveOptions]="{ exact: false }">
                        Dev Tool
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-10">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
